import { ReactNode } from 'react';

export const FeaturesContainer = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <div className="container m-auto mt-16 text-center text-blue lg:mb-36 lg:mt-[191px] lg:pl-[8%] lg:pr-[3%] lg:text-left">
    {children}
  </div>
);
